import { FetchAttributesActionTypes, UpdatePhoneNumberActionTypes, UpdateLanguageWithLocaleActionTypes, UpdateDefaultPhoneCountryCodeActionTypes, UpdateDefaultHomeActionTypes } from '../actions/AttributeActions';
import { FetchDefaultHomePageActionTypes } from '../actions/NavConfigActions';
import { handleActions } from 'flux-actions';
import UserAttributes from '../records/UserAttributes';
const initialState = new UserAttributes();
export default handleActions({
  [FetchAttributesActionTypes.SUCCESS](state, action) {
    return state.merge(action.payload.data);
  },
  [UpdateLanguageWithLocaleActionTypes.SUCCESS](state, action) {
    return state.mergeIn(['languageAndLocale'], action.payload.props);
  },
  [UpdateDefaultPhoneCountryCodeActionTypes.SUCCESS](state, action) {
    return state.set('defaultPhoneCountryCode', action.payload.props);
  },
  [UpdatePhoneNumberActionTypes.SUCCESS](state, action) {
    return state.set('phoneNumber', action.payload.props);
  },
  [UpdateDefaultHomeActionTypes.SUCCESS](state, action) {
    return state.set('defaultHome', action.payload.props);
  },
  [FetchDefaultHomePageActionTypes.SUCCESS](state, action) {
    return state.set('defaultHome', action.payload.data.homeKey);
  }
}, initialState);